import { Injectable, Inject, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import * as op from 'rxjs/operators';
import { first, map, mergeMap, tap, withLatestFrom } from 'rxjs/operators';
import {
  FiltersComponentInterface,
  FiltersTypeEnum,
  IFilterComboComponent,
  IFilterDateComponent,
  IFilterTextComponent,
  ViewDataService,
  WaHelperService,
  WCupSeasonLocator,
  WorldRankingCategoryListLocator
} from 'world-archery-lib';
import { BaseService } from '../../shared/base.service';
import { CountryCombo, DateFilterStore, RegionCombo } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { GenericNewsStore } from 'src/app/common-page-components/stores/entities-store/generic-news-store';
import { TranslocoService } from '@ngneat/transloco';
import { FiltersAbstractService } from '../../../common-page-components/classes/filters-abstract-service';
import { TextFilter } from '../../../common-page-components/stores/filters-store/filters-store';
import { DisciplineComboStore, IndividualTeamComboStore } from 'src/app/common-page-components/stores/entities-store/continental-ranking.store';
import { WorldRankingCategoriesStore} from '../../../common-page-components/stores/entities-store/world-ranking.store';
@Injectable({
  providedIn: 'root'
})
export class WorldRankingFiltersService extends FiltersAbstractService {


  /**
   * The news store for get the world ranking news.
   *
   * @memberof WorldRankingFiltersService
   */
  readonly newsStore = new GenericNewsStore(this.http, environment.news_api.world_ranking);

  /**
   * The text filter.
   *
   * @memberof WorldRankingFiltersService
   */
  textFilter = new TextFilter('wrankingextfilter', undefined, undefined, 'search');

  /**
   * The country combo.
   *
   * @memberof WorldRankingFiltersService
   */
  countryCombo = new CountryCombo('Country:', 'countrycombo', this.http, [{ item: { CShort: 'All' }, position: 0 }], 'country', false);

  /**
   * The discipline combo.
   *
   * @memberof WorldRankingFiltersService
   */
  disciplineCombo = new DisciplineComboStore('Discipline:', 'world_ranking_discipline_combo');

  /**
   * The individual team combo.
   *
   * @memberof WorldRankingFiltersService
   */
  individualTeamCombo = new IndividualTeamComboStore('Event:', 'world_ranking-event-combo');

  /**
   * The categories combo.
   *
   * @memberof WorldRankingFiltersService
   */
  categoriesCombo = new WorldRankingCategoriesStore('world-ranking', 'Category:', this.http, this.injector);

  /**
   * The date filter.
   *
   * @memberof WorldRankingFiltersService
   */
  dateFilter = new DateFilterStore('continental-ranking-data', 'Date:', undefined, undefined, undefined, undefined, new Date(), 'date_from');

  /**
   * The filters used in view.
   *
   * @type {FiltersComponentInterface}
   * @memberof WorldRankingFiltersService
   */
  readonly filtersType: FiltersComponentInterface = [

    this.textFilter.filterInfo,
    this.disciplineCombo.filterInfo,
    this.individualTeamCombo.filterInfo,
    this.categoriesCombo.filterInfo,

    this.dateFilter.filterInfo,
    this.countryCombo.filterInfo,

  ];
  constructor(
    public helper: WaHelperService,
    public views: ViewDataService,
    private http: HttpClient,
    private router_nav: Router,
    protected injector:Injector,
    private router: ActivatedRoute,
    protected translate_service:TranslocoService
  ) {
    super();
    this.newsStore.requestData({}, false).subscribe();
    combineLatest([
      this.disciplineCombo.comboData,
    ]).pipe(
      tap(([discipline]) =>
        this.categoriesCombo.requestData(
          {
            'RBP': 'ALL',
            'ParaArchery': discipline.Value === true ? 1 : undefined
          }, false)
          .subscribe()),
    )
      .subscribe();

  }

  /**
   * {@inheritdoc}
   *
   * @returns
   * @memberof WorldRankingFiltersService
   */
  getDataStreamWithFilters() {
    return combineLatest([
      this.orderValue,
      this.textFilter.data(300),
      this.categoriesCombo.comboData,
      this.dateFilter.data,
      this.disciplineCombo.comboData,
      this.countryCombo.comboData,
      this.individualTeamCombo.comboData,
    ]) as any;
  }

  /**
   * {@inheritdoc}
   *
   * @memberof WorldRankingFiltersService
   */
  generateDefaultValues(): void {
  }
}
